export default __webpack_public_path__ + "static/media/information--telephone-device-for-the-deaf--g1.3dd43d70.png";